import React,{ Component } from 'react';
import $ from 'jquery';
import { Link, browserHistory} from 'react-router';
import { Modal,Breadcrumb } from 'react-bootstrap';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class Web_MyAquaCash extends Component{
	constructor(props)
	{
		super(props);
		this.state=
		{
			loading:false,
			balance:'',
			transactions:[],

			title:'',
			subtitle:'',
			type:'',
			date:'',
			amount:'',
			sign:'',
			modal_status:false,
			deleteModal_status:false,
			deleteAll_modal_status:false,
		}
		this.transactionDetails=this.transactionDetails.bind(this);
		this.aquacash_Modal=this.aquacash_Modal.bind(this);
		this.close=this.close.bind(this);
		this.deleteSingle_AquaCash =this.deleteSingle_AquaCash.bind(this);
	    this.deleteSingleAc =this.deleteSingleAc.bind(this);
	    this.deleteallAC =this.deleteallAC.bind(this);
	    this.deleteAll =this.deleteAll.bind(this);  
	}
	transactionDetails()
	{
		if(localStorage.user_id)
		{
			var uid = localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		var data1={from:'desktop_web',id:uid,token:localStorage.getItem('token'),device_id:localStorage.getItem('push_device_id')}
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'aquaCash',
	          dataType: 'json',
	          data:{req: data2},
	          success: function(data)
	          {
	          	this.setState({
	          		loading:true,
	          		balance:data.balance,
	          		transactions:data.transactions,
	            });
	          }.bind(this),
	          error: function(err){
	          }
	    });
	}
	aquacash_Modal(title,subtitle,amount,sign,type,date)
	{
		this.setState({
			modal_status:true,
			title:title,
			subtitle:subtitle,
			type:type,
			date:date,
			amount:amount,
			sign:sign,
		});
	}
	deleteallAC()
	{
		 if(localStorage.user_id)
        {
        	var uid = localStorage.user_id;
        }
        else
        {
        	uid=0;
        }
		var data1={from:'desktop_web',uid:uid,token:localStorage.token};
	    var data2 =JSON.stringify(data1);
	   $.ajax({
          url:baseUrl+'deleteAquacash_user',
          method:'POST',
          dataType:'JSON',
          data:{req:data2},
          success:function(data)
          {
             if(data.status === 'success')
             {
              	this.setState({deleteAll_modal_status:false});
                this.transactionDetails();	 
             }
          }.bind(this),
          error:function(err)
          {

          }  
	   });

	}
	deleteSingle_AquaCash(id)
	{
       this.setState({
          aquaCash_id:id,
          deleteModal_status:true,
       });
	}
	deleteAll()
	{
	 this.setState({
	 	deleteAll_modal_status:true
	 });	
	}
	deleteSingleAc(acid)
	{ 
        if(localStorage.user_id)
        {
        	var uid = localStorage.user_id;
        }
        else
        {
        	uid=0;
        }
       var data1 ={from:'desktop_web',uid:uid,token:localStorage.token,aquacash_id:acid};		
	   var data2 =JSON.stringify(data1);
	   $.ajax({
         url:baseUrl+'deleteAquacash',
         method:'POST',
         dataType:'json',
         data:{req:data2},
         success:function(data)
         {
             if(data.status === 'success')
             {
             	this.setState({deleteModal_status:false});
                this.transactionDetails();
             } 
         }.bind(this),
         error:function(err)
         {

         }
	   }); 
	}
	componentDidMount()
	{
	
		localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_e_coupon_dt');
	    localStorage.removeItem('w_r_e_s_dt');
	    localStorage.removeItem('web_mycart');
	    localStorage.removeItem('w_r_enq_seller_page');
	    localStorage.removeItem('w_r_p_dt');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('web_ofr_page');
	    localStorage.removeItem('profile');
	    
	    localStorage.removeItem('web_share_earn');
	    localStorage.removeItem('checkout');
	    localStorage.removeItem('order_details');
	    localStorage.removeItem('myorders');
	    localStorage.removeItem('w_r_p_deals');
	    localStorage.removeItem('seed');
	    localStorage.removeItem('nauplii');
	    localStorage.removeItem('subdeals');
	    localStorage.removeItem('shipping');
	    localStorage.removeItem('notifications');
	    localStorage.removeItem('web_quickcart');
	    localStorage.removeItem('view_rating');
	    localStorage.removeItem('w_modal_seed');
	    localStorage.removeItem('w_r_seed_deals');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('w_modal_details');
	    localStorage.removeItem('offers');
	    localStorage.removeItem('give_rating');
	    localStorage.removeItem('pprice');
	    localStorage.removeItem('sprice');
	    localStorage.removeItem('seed_id');
	    localStorage.removeItem('h_type');
	    localStorage.removeItem('web_pro_ofr_dtls');
	    localStorage.removeItem('web_brand_details');
	    localStorage.removeItem('m_r_s_dt');
	    localStorage.removeItem('m_r_e_coupon_dt');
	    localStorage.removeItem('m_r_e_s_dt');
	    localStorage.removeItem('mob_mycart');
	    localStorage.removeItem('m_r_enq_seller_page');
	    localStorage.removeItem('m_r_p_dt');
	    localStorage.removeItem('m_r_e_p_dt');
	    localStorage.removeItem('ofr_page');
	    localStorage.removeItem('pro_ofr_dtls');
	    localStorage.removeItem('web_wishlist');

	    localStorage.removeItem('share_earn');
	    localStorage.removeItem('my_orders');
	    localStorage.removeItem('m_r_p_deals');
	    localStorage.removeItem('mob_quickcart');
	    localStorage.removeItem('partner_deals');
	    localStorage.removeItem('web_smartcart');

		if(screen.width < 800)
		{
			window.location.href="/myaquacash";
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('myaquacash','/web/myaquacash');
			browserHistory.push('/web/login');
		}
		else
		{
			this.transactionDetails();	
		}
	}
	close()
	{
		this.setState({
			modal_status:false,
		    deleteModal_status:false,
		    deleteAll_modal_status:false,
		});
	}

	render(){
	document.title ="My AquaCash | AquaDeals";
	var transactions= this.state.transactions.map(function(data,index){
		return(
			<li className="web_Myaquacash_Li" key={index} >
			  <div className='row web_Myaquacash_Row no-gutters'>	
				<div onClick={()=>{this.aquacash_Modal(data.title,data.subtitle,data.amount,data.sign,data.type,data.date)}}> 
				 <h5 className="col-md-5 col-sm-5">{data.title ? <span className="web_Aquacash_Title">{data.title}&nbsp;{data.subtitle ? <span>({data.subtitle})</span>:<span>&nbsp;</span>	}</span> : <span>&nbsp;</span>}</h5>
				 <h5 className="webaquacash_date col-md-2 col-sm-2">{data.date}</h5>
				 <h5 className="col-md-2 col-sm-2" style={{paddingLeft:'2px'}}>{data.type ? <span className={data.type === 'Used' ? "web_Aquacash_Type red" : "web_Aquacash_Type green"}>{data.type}</span> : <span>&nbsp;</span>}</h5>
				 <h5 className="col-md-2 col-sm-2" style={{paddingLeft:0}}>{data.amount ? <span className="pull-left">{data.sign === '+' ? <span className="green">(Cr)</span> : <span className="red">(Dr)</span> } &#8377; {data.amount}</span>: <span className="pull-left">&nbsp;</span>}</h5>
			    </div>
			    <i style={{marginRight:'15px'}} onClick={()=>{this.deleteSingle_AquaCash(data.id)}}><img src={baseAssets+'icons/web_icons/close_icon1.png'} width="13px" alt=""/></i>
			  </div>
			</li> 
		);
	}.bind(this));
	
		return(
			<div className="web_Deals web_aquacash_page">
				<WebHeaderInner />
				<section className="container cash_img_blk" style={{marginTop:'125px'}}>
					<div className="row">
                       <Link to={'/web/share_earn'}><img src={baseAssets+'images/promo_offers/my_aquacash.png'} alt=" " /></Link>
					</div>
				</section>
				<div className='container'>
				    <Breadcrumb className="aquacash_breadcrmb">
			           <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
			           <Breadcrumb.Item active>My Aquacash</Breadcrumb.Item>
		            </Breadcrumb>
				</div>
				<section className="container">
					<div className="row">
						<div className="col-md-12 col-lg-12 Dels_cntnt web_aquacash_cnt" style={{paddingBottom:'150px'}}>
							<div className="container-fluid" style={{marginTop:'25px'}}>
							   {this.state.transactions.length >0 ?
							   <a className="webMyaquacashAmount cursor" onClick={this.deleteAll}><i><img src={baseAssets+'icons/web_icons/del_bin3.png'} width="16px" alt=""/></i> Delete all</a>
							   :''}
							</div>
							<hr className={this.state.transactions.length > 0 ? 'show':'hide'}/>
							{transactions.length > 0 ? 
								<section>
									<ul className="web_myaquacash_ul">
									  <li className="row">
									  	 <h5 className="col-md-5 col-sm-5" style={{paddingLeft:'30px'}}>Description</h5>
									  	 <h5 className="col-md-2 col-sm-2" style={{paddingLeft:'30px'}}>Date</h5>
									  	 <h5 className="col-md-2 col-sm-2">Status</h5>
									  	 <h5 className="col-md-2 col-sm-2">Amount</h5>
									     <h5 className="col-md-1 col-sm-1">&nbsp;</h5>
									  </li>
										{transactions}
									</ul>
								</section> : <div className="web_no_Transactions_Blk">No transactions were made</div>}
								<Modal className="Aquacash_Modal" show={this.state.modal_status} onHide={this.close} >
									<Modal.Body>
							  			<div>
							  			    {this.state.title ? <h4>{this.state.title}</h4> : '' }
						  					<div>
						  						<p style={{marginTop:'20px'}}>{this.state.amount ? <span>&#8377;{this.state.amount}</span> : ''} {this.state.type ? this.state.type : ''} {this.state.subtitle ? 'for '+this.state.subtitle : ''} on {this.state.date} </p>
												<a style={{color:'#ff742a',textDecoration:'none',outline:'none',textAlign:'right',display:'block'}} onClick={this.close}>CLOSE</a>
						  					</div> 
										</div>
							  		</Modal.Body>
							  	</Modal>
							  	<Modal className="Aquacash_deleteModal" show={this.state.deleteModal_status} onHide={this.close} >
								   <Modal.Body style={{padding:'35px'}}>
							  		<div>
						  			   <div className="aquaCash_delete">
										  <p>Are you sure you want to delete this item</p>
										  <ul className="pull-right">	
										    <li className="cursor"><a onClick={this.close}>No</a></li>					
									        <li className="cursor"><a onClick={()=>{this.deleteSingleAc(this.state.aquaCash_id)}}>Yes</a></li>
									      </ul>
									   </div>
									</div>
							  	  </Modal.Body>
							  	</Modal>
							  	<Modal className="Aquacash_deleteModal" show={this.state.deleteAll_modal_status} onHide={this.close} >
								   <Modal.Body style={{padding:'35px'}}>
							  		<div>
						  			   <div className="aquaCash_delete">
										  <p>Are you sure you want to delete all items</p>
										  <ul className="pull-right">	
										    <li className="cursor"><a onClick={this.close}>No</a></li>					
									        <li className="cursor"><a onClick={()=>{this.deleteallAC()}}>Yes</a></li>
									      </ul>
									   </div>
									</div>
							  	  </Modal.Body>
							  	</Modal>
                         </div>
					  </div>
				</section>
				<WebFooter /> 
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Accounts/Web_My_Aquacash.js
 **/